export default __webpack_public_path__ + "static/media/trus18.91c72e85.png";